import React from "react";
import "./Gallery.css";

// ===== Data =====
const galleryImages = [
  { id: 1, src: "/Add on Course Images/Gallery 1.jpg" },
  { id: 2, src: "/2.jpg" },
  { id: 3, src: "/Add on Course Images/Sathya akka With students .jpg" },
  { id: 4, src: "/4.jpg" },
  { id: 5, src: "./carrier_support.jpg" },
  { id: 6, src: "./g1.png" },
  { id: 7, src: "./g2.png" },
  { id: 8, src: "./g3.png" },
  { id: 9, src: "./g4.png" },
  { id: 10, src: "./g5.png" },
  { id: 11, src: "./g6.png" },
  { id: 12, src: "./g11.png" },
  { id: 13, src: "./g7.png" },
  { id: 14, src: "./g9.png" },
  { id: 15, src: "./g10.png" },
  { id: 16, src: "./g8.png" },
  { id: 17, src: "./1.jpg" },
  { id: 18, src: "./2.jpg" },
  { id: 26, src: "./community_hub.jpg" },
  { id: 19, src: "./3.jpg" },
  { id: 20, src: "./4.jpg" },
  { id: 21, src: "./5.jpg" },
  { id: 22, src: "./6.jpg" },
  { id: 23, src: "./greenery_acre.jpg" },
  { id: 24, src: "./g12.png" },
];

const Gallery = () => {
  return (
    <div className="gallery-container">
      <section className="gallery-section">
        <h2 className="gallery-title">Our Gallery</h2>
        <div className="gallery-grid">
          {galleryImages.map((img) => (
            <div key={img.id} className="gallery-card">
              <img src={img.src} alt={`Gallery ${img.id}`} />
            </div>
          ))}
        </div>
      </section>
    </div>
  );
};

export default Gallery;
